"use client";

import { AnalyticsBrowser } from "@segment/analytics-next";
import { clientLogger } from "@/lib/client-logger";

let analytics: AnalyticsBrowser | undefined;

/**
 * Initialize and return the Segment analytics client.
 * This function is idempotent - it will only initialize once.
 */
export function getAnalytics(): AnalyticsBrowser | undefined {
  // Return existing instance if already initialized
  if (analytics) {
    return analytics;
  }

  // Check if we're in a browser environment
  if (typeof window === "undefined") {
    return undefined;
  }

  // Get the write key from environment variable
  const writeKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY;

  // Don't initialize if write key is missing (e.g., in development without Segment)
  if (!writeKey) {
    clientLogger.warn(
      "NEXT_PUBLIC_SEGMENT_WRITE_KEY is not set. Analytics will not be tracked.",
      "analytics-client",
    );
    return undefined;
  }

  // Initialize Segment analytics
  // AnalyticsBrowser.load() returns the Analytics instance immediately
  // and loads destinations in the background
  analytics = AnalyticsBrowser.load({
    writeKey,
  });

  return analytics;
}

/**
 * Reset the analytics client (useful for testing or logout scenarios)
 */
export function resetAnalytics(): void {
  analytics = undefined;
}
